module.exports = __webpack_public_path__ + "3841dfd81c5ad55b63284a4dcb339974.png";